import { useState, type FormEvent } from 'react';
import { ErreurApi } from '../api/client';
import { useAuth } from './AuthContext';

export function Connexion() {
  const { connecter } = useAuth();
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    setErreur(null);
    setEnvoi(true);
    try {
      await connecter(email, motDePasse);
    } catch (err) {
      setErreur(
        err instanceof ErreurApi
          ? err.estReseau
            ? "Le serveur ne répond pas. Vérifiez que l'API est démarrée."
            : err.message
          : 'Connexion impossible.',
      );
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <div className="connexion">
      <form onSubmit={soumettre}>
        <div className="brand" style={{ padding: 0, marginBottom: 18 }}>
          <div className="mark" aria-hidden="true"><i /><i /><i /><i /></div>
          <div>
            <b style={{ color: 'var(--ink)' }}>Mosaik Floor</b>
            <span>Flux commandes</span>
          </div>
        </div>

        <h1>Connexion</h1>
        <p className="hint">Accès réservé à l&apos;équipe.</p>

        <div className="field">
          <label htmlFor="c-email">Adresse email</label>
          <input
            id="c-email" type="email" autoComplete="username" required autoFocus
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="c-mdp">Mot de passe</label>
          <input
            id="c-mdp" type="password" autoComplete="current-password" required
            value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)}
          />
        </div>

        {erreur && <p className="err" role="alert">{erreur}</p>}

        <button className="btn pri" type="submit" style={{ width: '100%', marginTop: 8 }} disabled={envoi}>
          {envoi ? <><span className="spin" /> Connexion…</> : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
